/**
 * @constant BsUtilEmptyMarket Constant for empty market
 */
export const BsUtilEmptyMarket = {
    eventId: "0",
    leagueId: "0",
    isLive: false
};
/**
 * @constant BsUtilEmptySelection Constant for empty selection
 */
export const BsUtilEmptySelection = {
    id: "0",
    marketId: "0",
    group: 0,
    name: "",
    title: "",
    betslipLine: "",
    participantMapping: "",
    displayOdds: {},
    trueOdds: 0,
    points: 0,
    isDisabled: false,
    tags: [],
    metadata: {
        idSBTech: "0",
        type: "0"
    },
    status: ""
};
export const restrictedSportIds = ["61", "62", "66", "70", "73", "75"]; // SB-191937
//# sourceMappingURL=index.js.map